var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 186.54668,
    height: 148.05333,
    viewBox: "0 0 186.54668 148.05333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-R5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M 71.7383,746.723 5.25781,684.66 36.6914,415.742 h 32.6563 c -2.6993,46.149 -4.2891,95.559 -4.2891,147.52 0,65.699 2.5391,127.41 6.6797,183.461",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M 71.7383,746.723 5.25781,684.66 36.6914,415.742 h 32.6563 c -2.6993,46.149 -4.2891,95.559 -4.2891,147.52 0,65.699 2.5391,127.41 6.6797,183.461 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 1326.1,352.734 67.76,63.012 -29.62,268.91 h -32.26 c 1.86,-38.551 2.95,-79.09 2.95,-121.39 0,-76.508 -3.45,-147.481 -8.83,-210.532",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 1326.1,352.734 67.76,63.012 -29.62,268.91 h -32.26 c 1.86,-38.551 2.95,-79.09 2.95,-121.39 0,-76.508 -3.45,-147.481 -8.83,-210.532 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 700.008,1110.41 c -203.711,0 -430.18,-24.31 -514.11,-36.52 -57.652,-8.39 -73.632,-64.41 -73.632,-64.41 C 91.2578,935.828 65.0664,766.059 65.0664,555.25 c 0,-211 26.0899,-380.781 47.0896,-454.422 C 128.129,44.8008 185.785,36.3984 185.785,36.3984 269.727,24.1602 496.297,0 700.008,0 c 203.711,0 430.272,24.1602 514.222,36.3984 0,0 57.64,8.4024 73.63,64.4296 21,73.641 47.09,243.422 47.09,454.422 0,210.809 -26.19,380.578 -47.21,454.23 0,0 -15.97,56.02 -73.63,64.41 -83.93,12.21 -310.391,36.52 -514.102,36.52",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 700.008,1030.41 c 187.5,0 407.772,-21.89 502.582,-35.691 4.86,-0.707 7.79,-6.699 8.74,-9.008 15.39,-55.223 43.62,-213.32 43.62,-430.461 0,-219.961 -28.8,-379.078 -44.02,-432.469 -1.36,-4.761 -7.78,-6.871 -10.16,-7.5 C 1105.42,101.52 887.238,80 700.008,80 c -187.25,0 -405.43,21.52 -500.762,35.281 -2.379,0.629 -8.801,2.731 -10.16,7.481 -15.219,53.41 -44.02,212.527 -44.02,432.488 0,217.121 28.231,375.238 43.61,430.461 0.961,2.309 3.89,8.301 8.742,9.008 94.801,13.801 315.078,35.691 502.59,35.691",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M 8.06641,682.16 C 18.3438,594.191 28.6367,506.211 38.9141,418.238 H 1391.08 c -9.69,87.973 -19.38,175.953 -29.07,263.922 H 8.06641",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M 8.06641,682.16 C 18.3438,594.191 28.6367,506.211 38.9141,418.238 H 1391.08 c -9.69,87.973 -19.38,175.953 -29.07,263.922 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "m 617.633,800.551 51.281,-37.27 -19.59,-60.308 51.289,37.257 51.301,-37.257 -19.601,60.308 51.281,37.27 h -63.391 l -19.59,60.262 -19.59,-60.262 z m -127.75,0 19.59,60.262 19.582,-60.262 h 63.398 l -51.301,-37.27 19.621,-60.308 -51.3,37.257 -51.297,-37.257 19.597,60.308 -51.3,37.27 z m -254.528,0 51.278,-37.27 -19.617,-60.308 51.32,37.257 51.277,-37.257 -19.59,60.308 51.282,37.27 h -63.391 l -19.578,60.262 -19.613,-60.262 z m 636.821,0 19.578,60.262 19.601,-60.262 h 63.387 l -51.289,-37.27 19.61,-60.308 -51.309,37.257 -51.289,-37.257 19.59,60.308 -51.282,37.27 z m 127.75,0 51.274,-37.27 -19.59,-60.308 51.28,37.257 51.32,-37.257 -19.62,60.308 51.29,37.27 h -63.39 l -19.6,60.262 -19.58,-60.262 h -63.384",
    style: {
      fill: "#f68912",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 852.973,371.996 h 18.898 v 18.871 h -18.898 z m 18.879,-97.277 h -18.891 v 84.726 h 18.891 z m -44.84,116.148 c -1.399,-5.32 -19.25,-74.59 -19.25,-74.59 l -2.449,-11.429 -1.352,-0.02 -2.457,11.449 c 0,0 -18.652,73.578 -18.883,74.59 h -22.93 c 0.5,-1.738 34.641,-115.179 34.93,-116.148 h 18.672 c 0.277,0.976 33.77,114.41 34.289,116.148 z m -392.52,0.051 c 0.141,-1.223 12.828,-114.633 13.012,-116.16 h -20.383 v 0.058 c -0.129,2.262 -4.699,48.789 -6.629,68.653 l -0.801,8.09 -0.468,8.437 -1.391,0.133 -2.219,-8.57 c -0.883,-3.032 -20.769,-72.911 -22.121,-76.774 l -12.75,-0.027 c -0.59,3.211 -19.269,69.258 -21.41,76.801 -0.012,0.136 -2.25,8.879 -2.25,8.879 l -1.391,-0.129 -0.461,-8.59 c -0.078,-0.551 -7.269,-73.524 -7.41,-76.903 v -0.058 h -18.187 c 0.168,1.527 12.828,114.937 12.988,116.16 h 21.692 c 0.289,-1.012 20.789,-74.422 20.789,-74.422 l 2.39,-10.019 1.379,0.011 2.481,10.008 c 0,0 19.941,69.211 21.449,74.422 z m 637.398,-31.473 -23.59,-84.726 h -18.09 l -14.53,52.75 c -0.56,2.078 -0.96,4.097 -1.21,5.847 -0.29,-1.75 -0.7,-3.769 -1.31,-5.847 l -14.797,-52.75 h -18.109 l -23.57,84.726 h 20.507 l 12.301,-54.519 c 0.61,-2.571 0.942,-4.809 1.192,-6.598 0.347,1.809 0.808,4.039 1.519,6.649 l 14.787,54.468 h 16.88 l 14.21,-54.468 c 0.63,-2.391 1.1,-4.86 1.43,-6.872 0.29,2.051 0.66,4.551 1.23,7.012 l 12.93,54.328 z M 902.504,321.457 c 0,10.129 2.238,17.801 6.519,22.16 2.821,2.91 6.52,4.371 10.899,4.371 10.41,0 15.531,-7.34 15.648,-22.351 -1.168,-0.168 -31.558,-4.809 -33.066,-5.039 z m -18.203,-4.148 c 0,-27.641 14.679,-44.141 39.351,-44.141 14.078,0 22.911,3.25 27.852,5.969 l 0.508,0.289 -4.961,13.191 -0.688,-0.351 c -4.019,-2.059 -10.91,-4.559 -20.722,-4.559 -13.098,0 -20.239,7.191 -21.93,21.898 1.352,0.204 50.922,7.403 50.922,7.403 l 0.008,0.597 c 0.019,0.872 0.043,1.731 0.043,2.543 0,14.231 -3.411,24.95 -10.211,31.911 -5.782,5.918 -13.832,8.937 -23.93,8.937 -22.711,0 -36.242,-16.328 -36.242,-43.687 m -122.949,42.136 -38.52,-117.957 h -21.48 c 0,0 13.73,33.489 13.91,33.95 -0.16,0.507 -27.758,84.007 -27.758,84.007 h 21.617 c 0,0 14.512,-54.468 14.512,-54.488 0.687,-2.648 1.121,-5.078 1.347,-7.07 0.372,2.019 0.872,4.449 1.641,7.101 l 15.609,54.457 z M 633.441,321.457 c 0,10.129 2.219,17.801 6.512,22.16 2.82,2.91 6.488,4.371 10.899,4.371 10.402,0 15.519,-7.34 15.652,-22.351 -1.152,-0.168 -31.57,-4.809 -33.051,-5.039 0,0.3 -0.012,0.578 -0.012,0.859 m -18.23,-4.148 c 0,-27.641 14.691,-44.141 39.34,-44.141 14.121,0 22.941,3.25 27.89,5.969 l 0.512,0.289 -4.98,13.191 -0.719,-0.351 c -4.012,-2.059 -10.871,-4.559 -20.691,-4.559 -13.122,0 -20.243,7.191 -21.922,21.898 1.332,0.204 50.922,7.403 50.922,7.403 v 0.597 c 0.007,0.872 0.019,1.711 0.019,2.532 0,14.242 -3.41,24.961 -10.199,31.922 -5.762,5.918 -13.82,8.937 -23.922,8.937 -22.707,0 -36.25,-16.328 -36.25,-43.687 m -77.93,37.589 -0.39,-0.191 v -79.988 h 20.261 v 70.859 c 3.571,1.367 6.68,2.117 12.301,2.117 11.777,0 14.289,-7.179 14.289,-13.218 v -59.758 h 20.27 v 60.066 c 0,9.793 -4.399,26.211 -33.789,26.211 -13.25,0 -24.34,-2.051 -32.942,-6.098 m -62.679,-37.75 c 0,20.84 4.832,30.547 15.218,30.547 10.532,0 15.223,-9.429 15.223,-30.547 0,-20.582 -4.691,-29.769 -15.223,-29.769 -10.226,0 -15.218,9.738 -15.218,29.769 m -20.122,-0.16 c 0,-27.441 13.211,-43.82 35.34,-43.82 22.114,0 35.332,16.379 35.332,43.82 0,27.539 -13.218,44.008 -35.332,44.008 -22.129,0 -35.34,-16.469 -35.34,-44.008",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m 420.309,137.406 -17.95,36.426 c -1.679,3.469 -2.629,6.301 -2.629,6.301 h -0.312 c 0,0 0.312,-2.727 0.312,-6.301 v -36.426 h -14.382 v 72.227 h 14.382 l 15.54,-30.965 c 1.679,-3.359 3.25,-6.934 3.25,-6.934 h 0.214 c 0,0 -0.316,3.68 -0.316,7.039 v 30.86 h 14.379 v -72.227 h -12.488",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m 464.938,183.07 c -4.727,0 -5.567,-7.136 -5.567,-16.894 0,-9.766 0.84,-16.797 5.567,-16.797 4.828,0 5.566,7.031 5.566,16.691 0,9.754 -0.738,17 -5.566,17 z m 0,-46.718 c -14.172,0 -21.625,12.394 -21.625,29.394 0,16.906 7.554,29.297 21.625,29.297 14.277,0 21.625,-12.391 21.625,-29.297 0,-17 -7.458,-29.394 -21.625,-29.394",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m 521.313,137.406 h -15.637 l -14.488,56.582 h 16.375 l 6.406,-34.531 h 0.207 l 6.719,34.531 h 14.695 l -14.277,-56.582",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 561.852,183.707 c -4.414,0 -6.934,-6.934 -6.719,-15.441 l 12.597,1.582 c 0.102,8.496 -1.476,13.859 -5.878,13.859 z m -5.676,-25.617 c 0.949,-6.192 3.781,-9.238 9.976,-9.238 5.778,0 9.45,1.464 11.657,2.832 l 3.461,-11.133 c -3.883,-2.617 -9.555,-4.199 -17.637,-4.199 -15.856,0 -23.516,11.867 -23.516,29.503 0,16.063 7.77,29.188 22.153,29.188 15.429,0 22.257,-13.34 20.996,-33.594 l -27.09,-3.359",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m 645.102,137.406 v 39.473 c 0,3.984 -1.68,6.613 -5.352,6.613 -1.891,0 -3.359,-0.519 -4.512,-1.574 v -44.512 h -16.172 v 39.473 c 0,3.887 -1.679,6.613 -5.558,6.613 -2,0 -3.153,-0.312 -4.305,-0.84 v -45.246 h -16.062 v 53.438 c 4.511,2.414 10.808,4.199 20.367,4.199 8.5,0 13.015,-2.313 15.637,-5.039 2.941,2.726 7.558,5.039 15.433,5.039 10.078,0 16.59,-6.621 16.59,-18.164 v -39.473 h -16.066",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 692.574,183.598 c -1.476,0 -2.629,-0.215 -3.574,-0.625 v -34.539 c 0.84,-0.422 1.785,-0.637 2.836,-0.637 5.98,0 7.769,7.031 7.769,18.273 0,9.969 -1.468,17.528 -7.031,17.528 z m -1.789,-47.246 c -9.238,0 -14.805,1.894 -17.844,4.199 V 219.82 H 689 v -26.769 c 1.785,0.937 4.305,1.465 8.191,1.465 10.918,0 18.477,-10.496 18.477,-27.188 0,-20.574 -8.504,-30.976 -24.883,-30.976",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "m 745.387,183.707 c -4.407,0 -6.926,-6.934 -6.719,-15.441 l 12.598,1.582 c 0.105,8.496 -1.465,13.859 -5.879,13.859 z m -5.664,-25.617 c 0.937,-6.192 3.777,-9.238 9.968,-9.238 5.774,0 9.446,1.464 11.653,2.832 l 3.465,-11.133 c -3.887,-2.617 -9.551,-4.199 -17.637,-4.199 -15.848,0 -23.516,11.867 -23.516,29.503 0,16.063 7.766,29.188 22.149,29.188 15.441,0 22.258,-13.34 20.996,-33.594 l -27.078,-3.359",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 801.246,182.027 c -2.832,1.571 -6.094,1.68 -8.508,0.625 v -45.246 h -16.062 v 53.438 c 5.359,3.144 13.965,4.824 27.402,3.984 l -2.832,-12.801",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m 830.328,137.406 20.887,37.168 c 3.254,5.879 4.199,9.239 4.199,13.008 0,5.566 -3.465,9.981 -10.078,9.981 -3.875,0 -6.609,-1.153 -8.602,-2.208 l -3.886,11.133 c 3.777,2.414 9.656,4.2 16.797,4.2 16.484,0 21.941,-11.864 21.941,-21.426 0,-5.352 -2.207,-11.758 -7.137,-18.992 L 852.27,152.309 h 19.316 v -14.903 h -41.258",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 901.422,198.93 c -5.039,0 -5.676,-11.66 -5.676,-26.035 0,-14.278 0.637,-23.731 5.676,-23.731 5.137,0 5.879,9.453 5.879,23.731 0,14.375 -0.742,26.035 -5.879,26.035 z m 0,-62.578 c -17.121,0 -20.684,20.156 -20.684,37.168 0,17.011 3.563,37.168 20.684,37.168 17.109,0 20.781,-20.157 20.781,-37.168 0,-17.012 -3.672,-37.168 -20.781,-37.168",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m 925.777,137.406 20.887,37.168 c 3.254,5.879 4.199,9.239 4.199,13.008 0,5.566 -3.465,9.981 -10.078,9.981 -3.875,0 -6.609,-1.153 -8.601,-2.208 l -3.887,11.133 c 3.777,2.414 9.656,4.2 16.797,4.2 16.484,0 21.941,-11.864 21.941,-21.426 0,-5.352 -2.207,-11.758 -7.137,-18.992 l -12.179,-17.961 h 19.316 v -14.903 h -41.258",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 993.609,136.352 c -8.086,0 -13.546,1.367 -17.746,4.199 l 4.2,12.082 c 1.992,-1.367 5.351,-2.629 10.187,-2.629 5.137,0 9.336,4.199 9.336,9.551 0,7.14 -5.137,14.277 -20.676,10.5 l 3.672,39.578 h 31.178 V 194.73 h -20.678 l -1.055,-12.39 c 16.173,0.84 24.043,-9.238 24.043,-22.676 0,-12.492 -9.34,-23.312 -22.461,-23.312",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "m 414.453,942.336 c 0,11.531 -5.656,19.793 -20.25,19.793 -6.566,0 -12.316,-1.524 -15.828,-3.594 v -59.207 h 12.23 v 23.668 l 1.348,-0.09 c 15.942,-1.078 22.5,7.821 22.5,19.43 m -12.226,0.09 c 0,-6.028 -2.071,-11.52 -10.274,-10.988 l -1.348,0.089 v 21.621 c 0.899,0.36 2.071,0.54 3.418,0.54 6.493,0 8.204,-5.141 8.204,-11.262 m 41.476,6.203 c -11.156,0.539 -17.359,-0.891 -21.769,-3.5 v -45.801 h 11.601 v 39.957 c 2.25,1.082 5.309,1.172 8.012,-0.18 z m 38.344,-25.024 c 0,14.411 -5.762,25.114 -17.731,25.114 -11.882,0 -17.722,-10.703 -17.722,-25.114 0,-14.417 5.84,-25.187 17.722,-25.187 11.969,0 17.731,10.77 17.731,25.187 m -11.602,0.18 c 0,-8.738 -0.898,-15.949 -6.129,-15.949 -5.043,0 -6.031,7.211 -6.031,16.043 0,8.828 0.899,16.219 6.031,16.219 5.231,0 6.129,-7.481 6.129,-16.313 m 54.078,-21.769 v 67.941 h -11.687 v -22.488 c -1.172,0.449 -2.801,0.886 -5.68,0.886 -10.261,0 -17.453,-9.519 -17.453,-25.097 0,-16.121 7.102,-24.832 19.524,-24.832 7.199,0 11.699,1.34 15.296,3.59 m -11.687,5.75 c -0.902,-0.539 -2.16,-0.539 -3.25,-0.539 -5.941,0 -8.281,6.308 -8.281,16.66 0,9.09 1.89,16.57 8.64,16.57 1.09,0 2.078,-0.18 2.891,-0.359 z m 55.609,-5.571 v 45.621 h -11.781 v -39.058 c -1.258,-0.723 -2.891,-1.172 -4.687,-1.172 -3.782,0 -5.672,2.43 -5.672,6.301 v 33.929 h -11.692 v -32.578 c 0,-12.14 6.203,-16.812 17,-16.812 7.653,0 13.321,1.519 16.832,3.769 m 35.719,-0.179 -2.43,7.922 c -1.078,-1.09 -2.609,-1.809 -5.129,-1.809 -4.679,0 -7.558,5.949 -7.558,15.758 0,9.539 2.519,15.761 7.738,15.761 2.43,0 4.051,-0.902 4.949,-1.812 l 2.34,7.293 c -1.801,1.976 -4.859,3.59 -10.078,3.59 -9.172,0 -16.723,-8.531 -16.723,-25.012 0,-16.559 6.832,-25.281 16.723,-25.281 5.488,0 8.367,1.609 10.168,3.59 m 27.449,-2.071 v 8.364 c -0.629,-0.18 -1.347,-0.454 -2.429,-0.454 -2.43,0 -3.957,1.543 -3.957,6.043 v 25.207 h 6.386 v 8.711 h -6.386 v 14.219 l -11.692,-3.687 v -10.532 h -4.32 v -8.711 h 4.32 v -26.468 c 0,-8.551 4.32,-13.942 12.231,-13.942 2.699,0 5.129,0.711 5.847,1.25 m 47.16,-0.617 -14.027,27.84 v 0.18 c 5.848,1.347 11.238,7.75 11.238,15.32 0,11.801 -5.75,19.449 -20.418,19.449 -6.48,0 -11.972,-1.34 -15.66,-3.558 v -59.231 h 12.231 v 29.098 h 0.179 l 12.879,-29.098 z m -15.019,42.981 c 0,-7.032 -4.231,-11 -10.18,-11 -0.539,0 -0.898,0.089 -1.437,0.269 v 21.641 c 0.988,0.359 1.988,0.629 3.519,0.629 6.207,0 8.098,-4.512 8.098,-11.539 m 52.461,-40.293 v 28.89 c 0,13.321 -6.828,17.813 -15.918,17.813 -7.301,0 -12.152,-2.063 -14.942,-3.59 l 2.43,-7.652 c 2.602,1.359 6.199,2.531 10.262,2.531 4.226,0 6.93,-2.16 6.93,-6.762 v -1.617 c -12.973,-1.711 -22.141,-5.582 -22.141,-18 0,-9.633 5.848,-15.203 17.461,-15.203 7.558,0 12.406,1.34 15.918,3.59 m -11.238,5.121 c -0.903,-0.36 -2.524,-0.809 -4.141,-0.809 -4.602,0 -7.031,2.801 -7.031,7.75 0,7.02 3.699,9.539 11.172,10.527 z m 40.847,-7.192 v 8.364 c -0.629,-0.18 -1.347,-0.454 -2.429,-0.454 -2.43,0 -3.961,1.543 -3.961,6.043 v 25.207 h 6.39 v 8.711 h -6.39 v 14.219 l -11.688,-3.687 v -10.532 h -4.32 v -8.711 h 4.32 v -26.468 c 0,-8.551 4.32,-13.942 12.231,-13.942 2.699,0 5.128,0.711 5.847,1.25 m 20.071,62.102 c 0,3.512 -2.879,6.289 -6.391,6.289 -3.41,0 -6.199,-2.777 -6.199,-6.289 0,-3.418 2.789,-6.289 6.199,-6.289 3.512,0 6.391,2.871 6.391,6.289 m -0.45,-14.219 h -11.691 v -48.512 h 11.691 z m 44.461,-48.5 v 34.277 c 0,10.262 -5.492,15.114 -17.371,15.114 -7.379,0 -12.859,-1.434 -16.73,-3.59 v -45.801 h 11.601 v 39.957 c 1.258,0.633 2.43,0.903 4.86,0.903 4.148,0 5.859,-2.34 5.859,-6.583 v -34.277 z m 43.649,-0.359 v 46.16 c -2.789,2.066 -7.2,3.59 -14.032,3.59 -13.957,0 -20.789,-9.434 -20.789,-26.453 0,-14.5 6.379,-23.84 15.922,-23.84 3.52,0 5.77,0.801 7.207,1.883 v -2.512 c 0,-5.5 -2.34,-9.109 -8.379,-9.109 -4.589,0 -8.007,1.359 -9.808,2.71 l -3.051,-8.64 c 3.32,-2.34 7.91,-3.68 15.02,-3.68 10.621,0 17.91,6.199 17.91,19.891 m -11.692,8.976 c -1.617,-0.988 -2.879,-1.078 -4.148,-1.078 -5.309,0 -7.379,7.121 -7.379,16.211 0,10.617 2.16,17.199 7.93,17.199 1.531,0 2.789,-0.269 3.597,-0.629 z m 78.832,34.391 c 0,11.531 -5.672,19.793 -20.25,19.793 -6.57,0 -12.332,-1.524 -15.832,-3.594 v -59.207 h 12.231 v 23.668 l 1.351,-0.09 c 15.93,-1.078 22.5,7.821 22.5,19.43 m -12.23,0.09 c 0,-6.028 -2.07,-11.52 -10.27,-10.988 l -1.351,0.089 v 21.621 c 0.902,0.36 2.07,0.54 3.422,0.54 6.488,0 8.199,-5.141 8.199,-11.262 m 41.469,6.203 c -11.149,0.539 -17.36,-0.891 -21.758,-3.5 v -45.801 h 11.59 v 39.957 c 2.25,1.082 5.308,1.172 8.007,-0.18 z m 18.269,13.418 c 0,3.512 -2.867,6.289 -6.379,6.289 -3.418,0 -6.199,-2.777 -6.199,-6.289 0,-3.418 2.781,-6.289 6.199,-6.289 3.512,0 6.379,2.871 6.379,6.289 m -0.449,-14.219 h -11.688 v -48.512 h 11.688 z m 22.68,14.219 c 0,3.512 -2.868,6.289 -6.379,6.289 -3.418,0 -6.211,-2.777 -6.211,-6.289 0,-3.418 2.793,-6.289 6.211,-6.289 3.511,0 6.379,2.871 6.379,6.289 m -0.539,-57.602 v 43.383 h -11.598 v -44.73 c 0,-9.903 -3.063,-13.5 -6.844,-14.942 v -8.988 c 9.813,0.527 18.442,9.711 18.442,25.277 m 35.545,8.34 c 0,7.121 -3.59,10.641 -8.63,14.422 -4.32,3.148 -6.58,5.051 -6.58,8.199 0,2.43 1.81,4.602 4.69,4.602 2.97,0 5.22,-1.27 6.39,-2.352 l 2.78,7.473 c -2.78,2.25 -6.65,3.59 -11.87,3.59 -8.1,0 -13.583,-5.84 -13.583,-14.121 0,-6.403 4.043,-10.629 8.633,-14.063 4.32,-3.238 5.85,-4.68 5.85,-8.199 0,-2.699 -1.98,-4.5 -5.04,-4.5 -3.15,0 -6.03,1.441 -7.38,2.699 l -2.876,-8.539 c 2.786,-2.418 6.566,-3.578 12.046,-3.578 9.01,0 15.57,6.098 15.57,14.367",
    style: {
      fill: "#293a86",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 281.559,575.434 h 7.664 c 9.66,0 11.55,7.246 11.55,26.25 0,13.961 0,26.242 -11.023,26.242 h -8.191 z m -15.852,64.144 h 26.457 c 20.785,0 24.668,-13.855 24.668,-37.473 0,-11.656 1.785,-38.32 -25.301,-38.32 h -25.824 v 75.793",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m 333.219,563.785 v 75.793 h 15.851 v -75.793 h -15.851",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 382.25,606.824 h 7.035 c 6.301,0 8.082,6.301 8.082,11.129 0,7.246 -3.043,9.973 -8.082,9.973 h -7.035 z m 0,-43.039 h -15.848 v 75.793 h 29.286 c 10.816,0 17.746,-6.926 17.746,-19.836 0,-9.66 -3.782,-16.906 -14.071,-18.586 v -0.211 c 3.465,-0.418 13.758,-1.257 13.758,-14.906 0,-4.828 0.313,-19.105 1.781,-22.254 h -15.539 c -2.097,4.617 -1.675,9.766 -1.675,14.695 0,9.032 0.839,16.692 -11.34,16.692 h -4.098 v -31.387",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m 429.723,563.785 v 75.793 h 41.355 V 627.926 H 445.57 v -18.684 h 23.516 V 597.59 H 445.57 v -22.156 h 26.348 v -11.649 h -42.195",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 485.367,601.684 c 0,20.05 0,39.156 26.141,39.156 16.164,0 22.676,-8.922 22.043,-25.195 h -15.539 c 0,10.078 -1.782,13.859 -6.504,13.859 -8.926,0 -10.078,-8.399 -10.078,-27.82 0,-19.422 1.152,-27.821 10.078,-27.821 7.344,0 7.031,9.45 7.242,15.43 h 15.641 c 0,-20.262 -8.082,-26.77 -22.883,-26.77 -26.141,0 -26.141,19.317 -26.141,39.161",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M 596.559,639.578 V 626.98 H 578.922 V 563.785 H 563.066 V 626.98 H 545.43 v 12.598 h 51.129",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 633.414,563.785 v 75.793 h 15.856 v -75.793 h -15.856",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m 666.809,563.785 v 75.793 h 21.414 l 20.152,-52.488 h 0.215 v 52.488 h 14.805 v -75.793 h -20.899 l -20.676,55.43 h -0.215 v -55.43 h -14.796",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 775.473,616.273 c 0.109,7.032 -1.055,13.231 -9.453,13.231 -9.864,0 -9.864,-13.336 -9.864,-28.035 0,-23.719 2.305,-27.918 11.34,-27.918 2.617,0 5.457,0.625 7.871,1.465 v 16.797 h -8.613 v 11.656 h 24.461 v -38.426 c -4.305,-0.84 -15.117,-2.52 -21.414,-2.52 -26.66,0 -29.707,11.028 -29.707,39.786 0,19.113 0.945,38.531 26.875,38.531 15.535,0 25.195,-8.715 24.246,-24.567 h -15.742",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m 835.426,624.984 h -0.207 l -7.246,-32.754 h 15.117 z m -30.547,-61.199 20.996,75.793 h 20.887 l 20.578,-75.793 h -16.692 l -4.199,16.797 H 824.82 l -4.297,-16.797 h -15.644",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m 908.402,624.984 h -0.203 l -7.246,-32.754 h 15.117 z m -30.547,-61.199 20.997,75.793 h 20.89 l 20.574,-75.793 h -16.687 l -4.199,16.797 H 897.809 L 893.5,563.785 h -15.645",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m 953.871,563.785 v 75.793 h 21.418 l 20.156,-52.488 h 0.215 v 52.488 h 14.79 v -75.793 h -20.884 l -20.683,55.43 h -0.207 v -55.43 h -14.805",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 1044.17,575.434 h 7.66 c 9.67,0 11.55,7.246 11.55,26.25 0,13.961 0,26.242 -11.02,26.242 h -8.19 z m -15.85,64.144 h 26.46 c 20.78,0 24.67,-13.855 24.67,-37.473 0,-11.656 1.78,-38.32 -25.3,-38.32 h -25.83 v 75.793",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m 1095.73,563.785 v 75.793 h 41.36 v -11.652 h -25.51 v -18.684 h 23.51 V 597.59 h -23.51 v -22.156 h 26.35 v -11.649 h -42.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 454.707,458.785 v 75.789 h 15.856 v -63.191 h 23.718 v -12.598 h -39.574",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m 507.418,458.785 v 75.789 h 15.848 v -75.789 h -15.848",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "m 582.063,534.574 v -58.152 c 0,-13.234 -10.711,-18.899 -21.942,-18.899 -22.152,0 -23.094,9.239 -23.094,26.457 h 16.161 c 0,-6.085 -1.364,-15.117 6.933,-15.117 3.567,0 6.086,3.25 6.086,6.512 v 59.199 h 15.856",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m 598.977,458.785 v 75.789 h 39.367 V 522.926 H 614.828 V 503.5 h 22.461 v -11.648 h -22.461 v -33.067 h -15.851",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "m 667.535,501.82 h 7.035 c 6.297,0 8.082,6.309 8.082,11.133 0,7.246 -3.043,9.973 -8.082,9.973 h -7.035 z m 0,-43.035 h -15.851 v 75.789 h 29.289 c 10.812,0 17.742,-6.922 17.742,-19.832 0,-9.66 -3.777,-16.906 -14.067,-18.586 v -0.215 c 3.461,-0.41 13.754,-1.25 13.754,-14.902 0,-4.824 0.313,-19.101 1.786,-22.254 h -15.54 c -2.097,4.617 -1.679,9.766 -1.679,14.695 0,9.024 0.84,16.692 -11.336,16.692 h -4.098 v -31.387",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "m 714.996,458.785 v 75.789 h 41.367 v -11.648 h -25.508 v -18.684 h 23.516 v -11.66 h -23.516 v -22.148 h 26.348 v -11.649 h -42.207",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "m 772.113,458.785 v 75.789 h 21.418 l 20.157,-52.48 h 0.214 v 52.48 h 14.793 v -75.789 h -20.886 l -20.684,55.43 h -0.207 v -55.43 h -14.805",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m 893.285,534.574 v -12.597 h -17.637 v -63.192 h -15.847 v 63.192 h -17.637 v 12.597 h 51.121",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "m 906.617,458.785 v 75.789 h 41.367 v -11.648 h -25.507 v -18.684 h 23.515 v -11.66 h -23.515 v -22.148 h 26.347 v -11.649 h -42.207",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,148.05333)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyview);
export default __webpack_public_path__ + "static/media/moneyview.2b71ccd56b2da46a24e1716fd19580d7.svg";
export { ForwardRef as ReactComponent };